import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { LoggerService } from '../providers/logger.service';

@Component({
  selector: 'app-select-crop-points',
  template: `<div #abxElementWrapper><canvas #abxElement id='abx-element'></canvas></div>`,
  styles: [
  ]
})
export class SelectCropPointsComponent implements OnInit, AfterViewInit, OnChanges {

  canvas: any;// = $element.find("canvas")[0];
  element: any;// = $element;

  currentSelectedPointIndex = 0;
  currentPointDown = { x: 0, y: 0 };

  touchEvents = 'ontouchstart' in document.documentElement;

  largeCircleSize = 30;
  smallCircleSize = 20;

  @Input() initialPoints: any;
  @Input() active: boolean;
  @Output() selectPoints: EventEmitter<any> = new EventEmitter();
  @Output() cancelSelection: EventEmitter<any> = new EventEmitter();
  @Input() container: string = '';
  @Input() scale: any;

  @ViewChild("abxElement", { static: false }) abxElement: ElementRef;
  @ViewChild("abxElementWrapper", { static: false }) abxElementWrapper: ElementRef;
  currentPointIndex: any;

  constructor(private logger: LoggerService, private ngZone: NgZone, private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('active' in changes && changes['active'].currentValue === true) {
      this.setCanvas();
    }
  }

  ngAfterViewInit(): void {
    this.abxElementWrapper.nativeElement.addEventListener('pointerdown', (e) => {
      this.handleMouseDown(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchstart', (e) => {
      this.handleMouseDown(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointermove', (e) => {
      this.handleMouseMove(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('touchmove', (e) => {
      this.handleMouseMove(e);
    }, { passive: false });

    this.abxElementWrapper.nativeElement.addEventListener('pointerup', (e) => {
      this.handleMouseUp(e);
    }, { passive: false });

    this.setCanvas();
  }

  ngOnInit(): void {  }

  setCanvas() {
    try {
      //if ('x1' in this.initialPoints) initMouseListener(this.active);
      //else initMouseListener(false);
      const canvasEl: HTMLCanvasElement = this.abxElement.nativeElement;

      if (this.active) {

        // set the width and height
        if (document.getElementById(this.container)) {
          canvasEl.width = document.getElementById(this.container).offsetWidth;
          canvasEl.height = document.getElementById(this.container).offsetHeight;
        }

        var minSize = Math.min(canvasEl.width, canvasEl.height);

        if (this.touchEvents) {
          this.largeCircleSize = Math.ceil(minSize * 0.04);
          this.smallCircleSize = Math.ceil(minSize * 0.03);
        }
        this.canvas = canvasEl;
        this.drawCropPoints();

      } else {
        this.cancelSelection.emit();
      }

    } catch (e) {
      this.logger.logInternalError("SelectCropPoints:onInit", e.message);
    }
  }

  initMouseListener(active) {

    var element = undefined// document.body as HTMLElement;

    if (active) {
      if (this.touchEvents) {
        element.on("touchstart", this.handleMouseDown);
        element.on("touchend", this.handleMouseUp);
        element.on("touchcancel", this.handleMouseUp);
        element.on("touchmove", this.handleMouseMove);
      } else {
        element.on("mousedown", this.handleMouseDown);
        element.on("mouseup", this.handleMouseUp);
        element.on("mousemove", this.handleMouseMove);
        element.on("mouseleave", this.handleMouseLeave);
      }
    } else {
      if (this.touchEvents) {
        element.off("touchstart");
        element.off("touchend");
        element.off("touchcancel");
        element.off("touchmove");
      } else {
        element.off("mousedown");
        element.off("mouseup");
        element.off("mousemove");
        element.off("mouseleave");
      }
    }

  }

  drawCropPoints() {

    // Create a canvas for drawing in the background
    var canvas = document.createElement("canvas");
    canvas.width = this.canvas.width;
    canvas.height = this.canvas.height;
    var ctx = canvas.getContext("2d");

    // Draw the background image to canvas
    var img = document.getElementById('background') as HTMLImageElement;
    ctx.drawImage(img, 0, 0, img.width, img.height);

    // Setup the stroke style
    ctx.lineWidth = 5;
    ctx.strokeStyle = "#ffaa00";
    ctx.lineCap = "square";
    ctx.lineJoin = "round";

    // Draw rectangle
    ctx.moveTo(this.initialPoints.x1, this.initialPoints.y1);
    ctx.lineTo(this.initialPoints.x2, this.initialPoints.y2);
    ctx.lineTo(this.initialPoints.x3, this.initialPoints.y3);
    ctx.lineTo(this.initialPoints.x4, this.initialPoints.y4);
    ctx.lineTo(this.initialPoints.x1, this.initialPoints.y1);

    ctx.stroke();

    // Draw corner points
    ctx.beginPath();
    ctx.arc(this.initialPoints.x1, this.initialPoints.y1, this.largeCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(this.initialPoints.x2, this.initialPoints.y2, this.largeCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(this.initialPoints.x3, this.initialPoints.y3, this.largeCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(this.initialPoints.x4, this.initialPoints.y4, this.largeCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    // Draw middle points
    ctx.beginPath();
    ctx.arc((this.initialPoints.x1 + this.initialPoints.x2) / 2, (this.initialPoints.y1 + this.initialPoints.y2) / 2, this.smallCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc((this.initialPoints.x2 + this.initialPoints.x3) / 2, (this.initialPoints.y2 + this.initialPoints.y3) / 2, this.smallCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc((this.initialPoints.x3 + this.initialPoints.x4) / 2, (this.initialPoints.y3 + this.initialPoints.y4) / 2, this.smallCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    ctx.beginPath();
    ctx.arc((this.initialPoints.x4 + this.initialPoints.x1) / 2, (this.initialPoints.y4 + this.initialPoints.y1) / 2, this.smallCircleSize, 0, 2 * Math.PI);
    ctx.stroke();

    // Copy the background canvas to the real canvas
    var realCtx = this.canvas.getContext("2d");
    realCtx.drawImage(canvas, 0, 0);

  }


  distance(x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
  }

  getEventOffset(ev) {
    // Get the background position
    var background = document.getElementById(this.container);
    var backgroundPosition = background.getBoundingClientRect();

    // Get current zoom scale
    var scale = 1;
    //var transform = window.getComputedStyle(this.elementRef.nativeElement.parentElement).transform;
    var transform = document.getElementById("page").style.transform;
    if (transform !== undefined) {
      if (transform.startsWith("scale(")) {
        const transforArray = transform.substring(7).split(",");
        scale = parseFloat(transforArray[0]);
      }
    }

    // Scale the event position to the background image
    var clientX = this.touchEvents ? ev.touches[0].clientX : ev.clientX;
    var clientY = this.touchEvents ? ev.touches[0].clientY : ev.clientY;
    var p = {
      offsetX: Math.ceil((clientX - backgroundPosition.left) / this.scale),
      offsetY: Math.ceil((clientY - backgroundPosition.top) / this.scale)
    };

    // Bound the position to the background image
    p = {
      offsetX: Math.min(Math.max(p.offsetX, 0), background.offsetWidth),
      offsetY: Math.min(Math.max(p.offsetY, 0), background.offsetHeight)
    }

    // Don't scroll on touch events!
    if (this.touchEvents) ev.preventDefault();

    return p;
  }

  handleMouseDown(ev) {
    if (!this.active) return;
    try {

      var tag = ev.target.tagName;
      if (tag === 'I' || tag === 'BUTTON') return;

      var p = this.getEventOffset(ev);

      // corners
      if (this.distance(this.initialPoints.x1, this.initialPoints.y1, p.offsetX, p.offsetY) < this.largeCircleSize) this.currentSelectedPointIndex = 1;
      else if (this.distance(this.initialPoints.x2, this.initialPoints.y2, p.offsetX, p.offsetY) < this.largeCircleSize) this.currentSelectedPointIndex = 2;
      else if (this.distance(this.initialPoints.x3, this.initialPoints.y3, p.offsetX, p.offsetY) < this.largeCircleSize) this.currentSelectedPointIndex = 3;
      else if (this.distance(this.initialPoints.x4, this.initialPoints.y4, p.offsetX, p.offsetY) < this.largeCircleSize) this.currentSelectedPointIndex = 4;
      // sides
      else if (this.distance((this.initialPoints.x1 + this.initialPoints.x2) / 2, (this.initialPoints.y1 + this.initialPoints.y2) / 2, p.offsetX, p.offsetY) < this.smallCircleSize) this.currentSelectedPointIndex = 5;
      else if (this.distance((this.initialPoints.x2 + this.initialPoints.x3) / 2, (this.initialPoints.y2 + this.initialPoints.y3) / 2, p.offsetX, p.offsetY) < this.smallCircleSize) this.currentSelectedPointIndex = 6;
      else if (this.distance((this.initialPoints.x3 + this.initialPoints.x4) / 2, (this.initialPoints.y3 + this.initialPoints.y4) / 2, p.offsetX, p.offsetY) < this.smallCircleSize) this.currentSelectedPointIndex = 7;
      else if (this.distance((this.initialPoints.x4 + this.initialPoints.x1) / 2, (this.initialPoints.y4 + this.initialPoints.y1) / 2, p.offsetX, p.offsetY) < this.smallCircleSize) this.currentSelectedPointIndex = 8;
      // no selection
      else this.currentSelectedPointIndex = 0;

      this.currentPointDown = { x: p.offsetX, y: p.offsetY };
      ev.preventDefault();
      ev.stopPropagation();

    } catch (e) {
      this.logger.logInternalError("SelectCropPoints:handleMouseDown", e.message);
    }

  }

  handleMouseUp(ev) {
    if (!this.active) return;
    this.currentSelectedPointIndex = 0;

    this.selectPoints.emit({ points: this.initialPoints });

    ev.preventDefault();
    ev.stopPropagation();
    //this.ngZone.run(() => {  });
    //$scope.$apply => { this.selectPoints({ points: this.initialPoints }); });
  }

  handleMouseMove(ev) {

    try {
      if (!this.active) return;

      if (this.currentSelectedPointIndex === 0) return;

      var p = this.getEventOffset(ev);

      var dx = p.offsetX - this.currentPointDown.x;
      var dy = p.offsetY - this.currentPointDown.y;

      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;

      // Move points according to selection
      var width = this.canvas.width;
      var height = this.canvas.height;

      // Corner moves
      if (this.currentSelectedPointIndex === 1) {
        this.initialPoints.x1 = this.boundValue(this.initialPoints.x1 + dx, 0, Math.min(this.initialPoints.x2, this.initialPoints.x3));
        this.initialPoints.y1 = this.boundValue(this.initialPoints.y1 + dy, 0, Math.min(this.initialPoints.y3, this.initialPoints.y4));
      } else if (this.currentSelectedPointIndex === 2) {
        this.initialPoints.x2 = this.boundValue(this.initialPoints.x2 + dx, Math.max(this.initialPoints.x1, this.initialPoints.x4), width);
        this.initialPoints.y2 = this.boundValue(this.initialPoints.y2 + dy, 0, Math.min(this.initialPoints.y3, this.initialPoints.y4));
      } else if (this.currentSelectedPointIndex === 3) {
        this.initialPoints.x3 = this.boundValue(this.initialPoints.x3 + dx, Math.max(this.initialPoints.x1, this.initialPoints.x4), width);
        this.initialPoints.y3 = this.boundValue(this.initialPoints.y3 + dy, Math.max(this.initialPoints.y1, this.initialPoints.y2), height);
      } else if (this.currentSelectedPointIndex === 4) {
        this.initialPoints.x4 = this.boundValue(this.initialPoints.x4 + dx, 0, Math.min(this.initialPoints.x2, this.initialPoints.x3));
        this.initialPoints.y4 = this.boundValue(this.initialPoints.y4 + dy, Math.max(this.initialPoints.y1, this.initialPoints.y2), height);
        // Side moves
      } else if (this.currentSelectedPointIndex === 5) {
        this.initialPoints.y1 = this.boundValue(this.initialPoints.y1 + dy, 0, Math.min(this.initialPoints.y3, this.initialPoints.y4));
        this.initialPoints.y2 = this.boundValue(this.initialPoints.y2 + dy, 0, Math.min(this.initialPoints.y3, this.initialPoints.y4));
      } else if (this.currentSelectedPointIndex === 6) {
        this.initialPoints.x2 = this.boundValue(this.initialPoints.x2 + dx, Math.max(this.initialPoints.x1, this.initialPoints.x4), width);
        this.initialPoints.x3 = this.boundValue(this.initialPoints.x3 + dx, Math.max(this.initialPoints.x1, this.initialPoints.x4), width);
      } else if (this.currentSelectedPointIndex === 7) {
        this.initialPoints.y3 = this.boundValue(this.initialPoints.y3 + dy, Math.max(this.initialPoints.y1, this.initialPoints.y2), height);
        this.initialPoints.y4 = this.boundValue(this.initialPoints.y4 + dy, Math.max(this.initialPoints.y1, this.initialPoints.y2), height);
      } else if (this.currentSelectedPointIndex === 8) {
        this.initialPoints.x1 = this.boundValue(this.initialPoints.x1 + dx, 0, Math.min(this.initialPoints.x2, this.initialPoints.x3));
        this.initialPoints.x4 = this.boundValue(this.initialPoints.x4 + dx, 0, Math.min(this.initialPoints.x2, this.initialPoints.x3));
      } else {
        return;
      }

      this.currentPointDown = { x: p.offsetX, y: p.offsetY };

      this.drawCropPoints();
      ev.preventDefault();
      ev.stopPropagation();

    } catch (e) {
      this.logger.logInternalError("SelectCropPoints:handleMouseMove", e.message);
    }
  }

  boundValue(x, low, high) {
    if (x < low) return low;
    else if (x > high) return high;
    else return x;
  }

  handleMouseLeave(ev) {
  }

  /**
   * HostListeners 
   */

  //@HostListener('document:mousedown', ['$event'])
  //pressMouseEventHandler(event: MouseEvent) {
  //  this.handleMouseDown(event);
  //}

  //@HostListener('document:touchstart', ['$event'])
  //pressTouchEventHandler(event: TouchEvent) {
  //  this.handleMouseDown(event);
  //}

  //@HostListener('document:mousemove', ['$event'])
  //mouseDragEventHandler(event: MouseEvent) {
  //  this.handleMouseMove(event);
  //}

  //@HostListener('document:touchmove', ['$event'])
  //touchDragEventHandler(event: TouchEvent) {
  //  this.handleMouseMove(event);
  //}

  //@HostListener('document:mouseup', ['$event'])
  //mouseReleaseEventHandler(event: MouseEvent) {
  //  this.handleMouseUp(event);
  //}

  //@HostListener('document:touchend', ['$event'])
  //touchReleaseEventHandler(event: TouchEvent) {
  //  this.handleMouseUp(event);
  //}
}
